import { Environment } from '@/constants/environments';

export const getSourceForContactUsCRM = (environment: Environment) => {
	switch (environment) {
		case Environment.Prod:
			return 'Запрос обратной связи с прода';
		case Environment.Demo:
			return 'Запрос обратной связи с демо';
		case Environment.Test:
			return 'Запрос обратной связи с теста';
		default:
			return;
	}
};
